import DefaultScannerComponentCameraControlled from "@coworker/apprestructured/src/scan-and-search/DefaultScannerComponentCameraControlled";
import { ExtractedArticleInformationType } from "@coworker/apprestructured/src/scan-and-search/types/ExtractedArticleInformationType";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";

interface TestbuyItemSearchProps {
  setIsSearching: (isSearching: boolean) => void;
  handleScanResult: (productInfo: ExtractedArticleInformationType) => void;
  isSearching: boolean;
}
export const TestbuyItemSearch = ({
  handleScanResult,
  isSearching,
  setIsSearching,
}: TestbuyItemSearchProps) => {
  return (
    <FixaModal
      visible={isSearching}
      handleCloseBtn={() => setIsSearching(false)}
    >
      <FixaSheets
        header={<FixaModalHeader closeBtnClick={() => setIsSearching(false)} />}
        footer={null}
        fullSize
      >
        <DefaultScannerComponentCameraControlled
          onResult={handleScanResult}
          shouldHideSPRItems={false}
        />
      </FixaSheets>
    </FixaModal>
  );
};
